import React from 'react';
import {
  AppBar,
  Typography,
  makeStyles,
  createStyles,
  IconButton,
  Grid,
  Theme,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { mdiPlusCircle, mdiHome } from '@mdi/js';
import { Icon } from '@mdi/react';
import { AddDriverOrderForm } from '../components/addDriverOrderForm';
import { AddDriverParcelForm } from '../components/addDriverParcelForm';
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from 'react-query';

//Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    circularIcon: {
      color: '#2f4858',
      paddingLeft: '8px',
      position: 'fixed',
      bottom: 0,
      opacity: '90%',
    },
    topText: {
      color: '#2f4858',
      fontSize: '16px',
    },
    appBar: {
      padding: '12px',
      backgroundColor: '#ffffff',
      zIndex: theme.zIndex.drawer + 1,
      boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2)',
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  })
);

export const AddDriverEntrance = (props: {}) => {
  const classes = useStyles();
  const filter = new URLSearchParams(window.location.search).get("filter")

  return (
    <div>
      <AppBar className={classes.appBar}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography className={classes.topText} variant="h6">
              ورود راننده
            </Typography>
          </Grid>
          <Grid item>
            <Link to="/security/">
              <IconButton>
                <Icon path={mdiHome} size={1} />
              </IconButton>
            </Link>
          </Grid>
        </Grid>
      </AppBar>
      <QueryClientProvider client={new QueryClient()}>
        {filter == "ORDER" ? <AddDriverOrderForm /> : <AddDriverParcelForm />}
      </QueryClientProvider>
    </div>
  );
};
